import React from 'react';
import { Construction } from 'lucide-react';

const AdminComingSoonPage = ({ title }) => (
  <div className="flex flex-col items-center justify-center min-h-[60vh] text-center p-6">
    <div
      className="flex items-center justify-center mb-6"
      style={{
        width: 64, height: 64,
        borderRadius: 'var(--r-lg, 16px)',
        background: 'var(--surface-3, #e8e7e3)',
        color: 'var(--on-surface-dim, #6b6b63)',
      }}
    >
      <Construction size={28} />
    </div>
    <h2
      style={{
        fontSize: 'var(--text-lg, 18px)',
        fontWeight: 700,
        color: 'var(--on-surface, #1a1a17)',
        marginBottom: 8,
      }}
    >
      {title}
    </h2>
    <p
      style={{
        fontSize: 'var(--text-sm, 14px)',
        color: 'var(--on-surface-dim, #6b6b63)',
        maxWidth: 320,
      }}
    >
      This feature is coming soon.
    </p>
  </div>
);

export default AdminComingSoonPage;
